// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    header: {
        size: {
            sticky: 56,
            height: 138,
        },
        mobile: {
            size: {
                authenticated: 100,
                unAuthenticated: 54,
            },
        },
        tablet: {
            size: {
                authenticated: 58,
                unAuthenticated: 54,
            },
        },
    },
    footer: {
        offsetTop: 44,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 230,
            height: 230,
        },
        mobile: {
            width: 280,
            height: 280,
        },
    },
};

export const XNGAGE_CUSTOM_WIDGET = "Xngage" as any;
export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const placeHolders = {
    email: "eg. example@gmail.com",
    phone: "( ___ ) ___ - ____",
};

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    FINANCE = "Finance",
    REQUISITIONER = "Requisitioner",
}

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};

export const TESTIMONIALS_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 1,
    tablet: 1,
    desktop: 2,
};

export const FEATURED_CATEGORIES_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 1.5,
    tablet: 3.3,
    desktop: 6,
};

export const PRODUCT_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 1,
    tablet: 2,
    desktop: 3.7,
    wideScreen: 4.5,
};

export const checkoutPages = ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage", "OnePageCheckoutPage"];

export const interactionPages = [
    "CheckoutShippingPage",
    "CheckoutReviewAndSubmitPage",
    "OnePageCheckoutPage",
    "CartPage",
    "ProductDetailsPage",
    "ProductListPage",
    "OrderConfirmationPage",
];

export const ErrorApiDefaultMessage = "Please try again and contact support if you continue to have issues.";

export const SHOW_ALL_BRANDS_KEY = "all";

export const TRANSLATE_OBJECT = { translate: "no" };
export const SHIPPING_FORM = "ShippingForm";
